import SEOArticlePage from "@/components/feature/SEOArticlePage";
import { articleContents } from "@/mocks/seo-article-content";

export default function ErreursAEviter() {
  return <SEOArticlePage article={articleContents["erreurs-a-eviter"]} />;
}